import { render, staticRenderFns } from "./FormTourist.vue?vue&type=template&id=ae5a321c&"
import script from "./FormTourist.vue?vue&type=script&lang=js&"
export * from "./FormTourist.vue?vue&type=script&lang=js&"
import style0 from "./FormTourist.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports